import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import { CHANGE_EVENT } from '../constants/AppConstants';
import AccountsPreferenceConstants from '../constants/AccountsPreferenceConstants';
import StatementsPreferencesApiUtils from '../utils/StatementsPreferencesApiUtils';
let _statementPrefData = [];
let _backPageReference = '';
let _setStatementPreferenceSuccess = false;
let _setStatementPreferenceError = false;

class StatementsPreferencesStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  getPreferences() {
    return _statementPrefData;
  }
  getBackPageReference() {
    return _backPageReference;
  }
  setStatementPreferenceSuccess() {
    return _setStatementPreferenceSuccess;
  }
  setStatementPreferenceError() {
    return _setStatementPreferenceError;
  }
  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action;
    switch (actionType) {
      case AccountsPreferenceConstants.REQUEST_STATEMENT_PREFERENCES:
        _statementPrefData = [];
        StatementsPreferencesApiUtils.getPreferences();
        break;
      case AccountsPreferenceConstants.REQUEST_STATEMENT_PREFERENCES_SUCCESS:
        _statementPrefData = [];
        if (actionData.setStmtFlag) {
          _setStatementPreferenceSuccess = true;
          _setStatementPreferenceError = false;
        }
        _statementPrefData = actionData.data;
        this.emitChange();
        break;
      case AccountsPreferenceConstants.STATEMENT_BACKPAGE_REFERENCE:
        _backPageReference = actionData.urlString;
        break;
      case AccountsPreferenceConstants.SET_STATEMENT_PREFERENCES:
        _setStatementPreferenceSuccess = false;
        _setStatementPreferenceError = false;
        StatementsPreferencesApiUtils.setStatementPreferenceCall(
          actionData.data
        );
        break;
      case AccountsPreferenceConstants.REQUEST_STATEMENT_PREFERENCES_ERROR:
        _setStatementPreferenceSuccess = false;
        _setStatementPreferenceError = true;
        this.emitChange();
        break;
      default: {
        break;
      }
    }
  }
}

export default new StatementsPreferencesStore();
